module.exports = __webpack_public_path__ + "media/images/flags/MU-da6828a77b1a3b24e59e809f78b71786.svg";